function Minus() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none" viewBox="0 0 14 4">
      <path fill="#fff" d="M0 1a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"></path>
    </svg>
  )
}

export default Minus
